<template>
  <el-form
    ref="lform"
    :model="form"
    :rules="rules"
    label-position="top"
  >
    <el-row>
      <el-col
        :span="8"
      >
        <el-form-item
          label="PO Box"
          prop="pobox"
        >
          <el-switch
            v-model="form.pobox"
            active-text="Yes"
            inactive-text="No"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row
      :gutter="10"
    >
      <el-col
        :span="12"
      >
        <el-form-item
          label="Suburb"
        >
          <el-input
            v-model="form.suburb"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
      >
        <el-form-item
          label="Postcode"
        >
          <el-input
            v-model="form.postcode"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row
      :gutter="10"
    >
      <el-col
        :span="12"
      >
        <el-form-item
          label="State"
        >
          <el-input
            v-model="form.state"
          />
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
      >
        <el-form-item
          label="Country"
          prop="country"
        >
          <el-select
            v-model="form.country"
            class="w-100"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

      rules: {
        pobox: [
          { required: true, message: 'PO Box is required', trigger: 'blur' }
        ],
        country: [
          { required: true, message: 'Country is required', trigger: 'blur' }
        ]
      },
      options: [{
        value: 'AU',
        label: 'Australia'
      },
      {
        value: 'NZ',
        label: 'New Zealand'
      }]
    }
  },
  methods: {

  }
}
</script>

<style>

</style>
